<template>
  <div class="p-12px bg-color-[#fff]">
    <remote-table
      ref="tableRef"
      menuName="announcementCenter"
      has-action
      showSetting
      interfaceURL="announcement-center/page"
      :y="state.scrollY"
      :sy="state.scrollY"
      :showSelection="false"
    >
      <template #effectiveTimeStrCR="{record}">
        {{ record.effectiveTimeStr
        }}<a-button
          danger
          v-if="record.expireFlag"
          size="small"
          class="ml-8px bg-color-[#FFF1F0]"
          >已过期</a-button
        >
      </template>
      <template #statusStrCR="{record}">
        <a-badge
          :status="
            record.status === 1
              ? 'success'
              : record.status === 0
              ? 'default'
              : record.status === 2
              ? 'error'
              : ''
          "
          :text="record.statusStr"
        />
      </template>
      <template #btns>
        <div class="text-right">
          <a-button
            :disabled="!state.hasPermission"
            size="small"
            type="primary"
            @click=";(state.id = null), (state.showAddNotice = true)"
            >新增发布</a-button
          >
        </div>
      </template>
      <!-- 0:草稿 1:已发布 2:已撤回 -->
      <template #action="{ record }">
        <a-button
          size="small"
          type="link"
          class="mr-8px"
          @click=";(state.id = record.id), (state.showDetail = true)"
          >详情</a-button
        >
        <a-popconfirm
          title="是否确定发布？"
          ok-text="是"
          cancel-text="否"
          @confirm="updateStatus(record.id, 1)"
          :disabled="!state.hasPermission"
        >
          <a-button
            size="small"
            type="link"
            class="mr-8px"
            :disabled="!state.hasPermission"
            v-if="[0, 2].includes(record.status)"
            >发布</a-button
          >
        </a-popconfirm>
        <a-popconfirm
          title="是否确定撤回？"
          ok-text="是"
          cancel-text="否"
          @confirm="updateStatus(record.id, 2)"
          :disabled="!state.hasPermission"
        >
          <a-button
            size="small"
            type="link"
            class="mr-8px"
            v-if="record.status === 1"
            :disabled="!state.hasPermission"
            >撤回</a-button
          >
        </a-popconfirm>
        <a-button
          size="small"
          type="link"
          class="mr-8px"
          v-if="record.status === 1"
          @click=";(state.id = record.id), (state.showReadingRecord = true)"
          >阅读记录</a-button
        >
        <a-button
          size="small"
          type="link"
          class="mr-8px"
          v-if="[0, 2].includes(record.status)"
          @click=";(state.id = record.id), (state.showAddNotice = true)"
          :disabled="!state.hasPermission"
          >修改</a-button
        >
        <p-log
          type="link"
          :showButton="true"
          :logParams="{
            bizType: 201,
            bizId: record.id
          }"
          >日志</p-log
        >
      </template>
    </remote-table>
  </div>
  <add-notice v-if="state.showAddNotice" :id="state.id" />
  <noticeDetail
    v-if="state.showDetail"
    :showDetail="state.showDetail"
    :id="state.id"
    isFromNotice
    @close="state.showDetail = false"
  />
  <readingReocrd v-if="state.showReadingRecord" :id="state.id" />
  <noticeInfoList v-if="state.showNoticeInfoList" :id="state.id" />
</template>
<script setup>
import { useNoticePublish } from './share'
import addNotice from './components/addNotice.vue'
import noticeDetail from './components/noticeDetail.vue'
import readingReocrd from './components/readingRecord.vue'
import noticeInfoList from './components/noticeInfoList.vue'
import { provide } from 'vue'
const noticePublishModule = useNoticePublish()
const { state, tableRef, updateStatus } = noticePublishModule
provide('noticePublishModule', noticePublishModule)
</script>
<style lang="scss" scoped>
:deep(.portal-ant-badge-status-text) {
  font-size: 12px;
}
:deep(.portal-ant-popover-message-title) {
  font-size: 12px !important;
}
</style>
